// Package
import axios from "axios";
import { store } from '../store/store';
import { removeAccessToken, setIsAuth } from "../store/reducers/auth/authReducer";
import { resetInformation } from "../store/reducers/user/userReducer";
import { getCookie, removeCookie } from '../utils/CookiesUtil';
import { notification } from "../utils/Notifications.js";

const { REACT_APP_API_URL } = process.env;

const apiClient = axios.create({
  baseURL: `${REACT_APP_API_URL}`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const get = async (url, authToken = null, config = {}) => {
  try {

    const headers = {
      "Content-Type": "application/json",
      ...(authToken && { auth_token: authToken }),
    };

    const response = await apiClient.get(url, { ...config, headers });
    return response.data;
    
  } catch (error) {
    throw error;
  }
};

export const post = async (url, data, authToken = null, config = {}) => {
  try {

    const headers = {
      "Content-Type": "application/json",
      ...(authToken && { auth_token: authToken }),
    };
 
    const response = await apiClient.post(url, data, { ...config, headers });
    return response.data;

  } catch (error) {
    throw error;
  }
};


// ✅ Crear instancia base de axios
const api = axios.create({
  baseURL: REACT_APP_API_URL,
  headers: { "content-type": "application/json" },
});

// ✅ Interceptor para agregar token automáticamente
api.interceptors.request.use(
  (config) => {
    const token = getCookie("accessToken");
    if (token) config.headers["auth_token"] = token;
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Interceptor global para manejar 401 y 403 (sesión expirada o inválida)
api.interceptors.response.use(
  async (response) => {
    if (response.data?.status_Code === 401 || response.data?.status_Code === 403) {
      
      let message = response?.data?.status_Message || "Los permisos han cambiado, inicia sesión nuevamente.";

      if (message === "Signature has expired") {
        message = "Sesión expirada. Por favor, inicia sesión nuevamente.";
      }

      // 1️⃣ Limpiar cookies
      removeCookie("accessToken");

      // 2️⃣ Resetear Redux
      store.dispatch(removeAccessToken());
      store.dispatch(setIsAuth({ isAuth: false }));
      store.dispatch(resetInformation());

      notification({
        text: message,
        type: "error",
      });

      await delay(1000);

      // 4️⃣ Redirigir al login usando window.location.replace para evitar problemas con React Router
      window.location.replace("/acceso");
    }
    return response;
  },
  async (error) => {
    if (error.response?.data?.status_Code === 401 || error.response?.data?.status_Code === 403) {
      
      let message = error.response?.data?.status_Message || "Los permisos han cambiado, inicia sesión nuevamente.";

      if (message === "Signature has expired") {
        message = "Sesión expirada. Por favor, inicia sesión nuevamente.";
      }

      // 1️⃣ Limpiar cookies
      removeCookie("accessToken");

      // 2️⃣ Resetear Redux
      store.dispatch(removeAccessToken());
      store.dispatch(setIsAuth({ isAuth: false }));
      store.dispatch(resetInformation());

      // 3️⃣ Mostrar notificación
      notification({
        text: message,
        type: "error",
      });

      await delay(1000);

      // 4️⃣ Redirigir al login usando window.location.replace para evitar problemas con React Router
      window.location.replace("/acceso");
    }

    return Promise.reject(error);
  }
);

export default api;